import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { getAuth } from 'firebase/auth'

import { readMetaBrowserContext } from '@/integrations/meta-pixel'
import authenticationService from '@/services/authentication/authentication'

export async function refreshIdTokenInterceptor(response: AxiosResponse) {
  const shouldRefreshIdToken = !!response.headers['x-refresh-id-token']
  if (shouldRefreshIdToken) await authenticationService.refreshIdToken()

  return response
}

export async function attachAuthorizationHeaderInterceptor(config: AxiosRequestConfig) {
  if (getAuth().currentUser) {
    const authToken = await getAuthorizationToken()
    config.headers = { ...config.headers, Authorization: authToken }
  }

  return config
}

/**
 * Forwards the Meta browser cookies to the backend on every API call.
 *
 * Sent as headers rather than in request bodies so that no endpoint schema has to change
 * to carry them — which also means the generated API client stays untouched. The backend
 * reads them in `trackingContextFromHeaders` and attaches them to whichever funnel event
 * that request produces.
 */
export async function attachMetaContextInterceptor(config: AxiosRequestConfig) {
  const { fbc, fbp } = readMetaBrowserContext()

  if (fbp || fbc) {
    config.headers = {
      ...config.headers,
      ...(fbp ? { 'x-fb-browser-id': fbp } : {}),
      ...(fbc ? { 'x-fb-click-id': fbc } : {}),
    }
  }

  return config
}

export async function logResponseInterceptor(response: AxiosResponse) {
  const {
    config: { data, method = 'UNKNOWN', url },
    status,
  } = response

  if (status >= 400) console.error(`🌎 [${method.toUpperCase()}] ${url} - ${status}`, data)
  else console.log(`🌎 [${method.toUpperCase()}] ${url} - ${status}`)

  return response
}

async function getAuthorizationToken() {
  const idToken = await getAuth().currentUser?.getIdToken()

  return `Bearer ${idToken}`
}
